import eventsNavigationNames from '../events/navigation';
import { useSendEvent } from '../useSendEvent';

const useNavAboutClicked = () =>
	useSendEvent(eventsNavigationNames.navLinkAboutClick, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useNavTopGridButtonClicked = () =>
	useSendEvent(eventsNavigationNames.navTopGridButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});
const useNavLeftGridButtonClicked = () =>
	useSendEvent(eventsNavigationNames.navLeftGridButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useNavTopGalleryClicked = () =>
	useSendEvent(eventsNavigationNames.navTopGalleryClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});
const useNavLeftGalleryClicked = () =>
	useSendEvent(eventsNavigationNames.navLeftGalleryClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useNavTopChatsButtonClicked = () =>
	useSendEvent(eventsNavigationNames.navTopChatsButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});
const useNavLeftChatsButtonClicked = () =>
	useSendEvent(eventsNavigationNames.navLeftChatsButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useNavTopCreateCharacterButtonClicked = () =>
	useSendEvent(
		eventsNavigationNames.navTopCreateCharacterButtonClicked,
		undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);
const useNavLeftCreateCharacterButtonClicked = () =>
	useSendEvent(
		eventsNavigationNames.navLeftCreateCharacterButtonClicked,
		undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);

const useNavTopCreateImageButtonClicked = () =>
	useSendEvent(
		eventsNavigationNames.navTopCreateImageButtonClicked,
		undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);
const useNavLeftCreateImageButtonClicked = () =>
	useSendEvent(
		eventsNavigationNames.navLeftCreateImageButtonClicked,
		undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);

const useNavTopCreateVideoButtonClicked = () =>
	useSendEvent(
		eventsNavigationNames.navTopCreateVideoButtonClicked,
		undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);
const useNavLeftCreateVideoButtonClicked = () =>
	useSendEvent(
		eventsNavigationNames.navLeftCreateVideoButtonClicked,
		undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);

const useNavTopLoginButtonClicked = () =>
	useSendEvent(eventsNavigationNames.navTopLoginButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useNavTopSettingsButtonClicked = () =>
	useSendEvent(eventsNavigationNames.navTopSettingsButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useNavTopSignOutButtonClicked = () =>
	useSendEvent(eventsNavigationNames.navTopSignOutButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useNavTopMySubscriptionButtonClicked = () =>
	useSendEvent(
		eventsNavigationNames.navTopMySubscriptionButtonClicked,
		undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);

const useNavLeftAffiliateButtonClicked = () =>
	useSendEvent(eventsNavigationNames.navLeftAffiliateButtonClicked, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useNavLeftPartnershipButtonClicked = () =>
	useSendEvent(
		eventsNavigationNames.navLeftPartnershipButtonClicked,
		undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);

const annalsNavigation = {
	useNavAboutClicked,
	useNavTopGridButtonClicked,
	useNavLeftGridButtonClicked,
	useNavTopGalleryClicked,
	useNavLeftGalleryClicked,
	useNavTopChatsButtonClicked,
	useNavLeftChatsButtonClicked,
	useNavTopCreateCharacterButtonClicked,
	useNavLeftCreateCharacterButtonClicked,
	useNavTopCreateImageButtonClicked,
	useNavLeftCreateImageButtonClicked,
	useNavTopCreateVideoButtonClicked,
	useNavLeftCreateVideoButtonClicked,
	useNavTopLoginButtonClicked,
	useNavTopSettingsButtonClicked,
	useNavTopSignOutButtonClicked,
	useNavLeftAffiliateButtonClicked,
	useNavLeftPartnershipButtonClicked,
	useNavTopMySubscriptionButtonClicked,
};

export default annalsNavigation;
